<script>
  export let user

  import { onMount } from 'svelte'

  import Tab from '../components/tabs/Tab.svelte'
  import Tabbed from '../components/tabs/Tabbed.svelte'
  import TabContent from '../components/tabs/TabContent.svelte'

  import VideoContent from '../components/VideoContent.svelte'
  import FileItem from '../components/FileItem.svelte'

  import videoService from '../../api/videos'

  let tabs = [
    { name: 'Videos', data_key: 'videos', id: 'videos', isInitial: true },
    { name: 'Spitex', data_key: 'files_spitex', id: 'spitex', hidden: true },
    { name: 'Ärzt*innen', data_key: 'files_docs', id: 'docs', hidden: true }
  ]

  if (user.affiliation) {
    const formattedAffiliation = user.affiliation
      .toLowerCase()
      .replace(' ', '_')

    tabs.push({
      name: user.affiliation,
      data_key: `files_${formattedAffiliation}`,
      id: formattedAffiliation
    })
  }

  $: activeTab = tabs.find((tab) => tab.isInitial)

  const fileData = {}

  let isLoading

  onMount(async () => {
    isLoading = true

    const { data } = await videoService.getFiles({
      user: user.email,
      password: user.password
    })

    tabs
      .filter((tab) => tab.hidden !== true)
      .forEach((tab) => {
        const tabData = data.content[tab.data_key]
          ? [...data.content[tab.data_key]]
          : []

        fileData[tab.data_key] = tabData
      })

    // videos = data.content.videos ? [...data.content.videos] : []
    isLoading = false
  })

  /**
   * @param {evt} MouseEvent
   */
  function onTabClick(evt) {
    const { id } = evt.target

    let tabToActivate = tabs.find((t) => t.id === id.replace('tab-', ''))

    if (tabToActivate.id !== activeTab.id) {
      tabToActivate.isActive = true

      activeTab = tabToActivate
    }
  }

</script>

{#if isLoading}
  <p>Inhalte werden geladen.</p>
{/if}

{#if !isLoading}
  <Tabbed>
    <div slot="tabs">
      {#each tabs.filter((tab) => tab.hidden !== true) as tab (tab.id)}
        <Tab
          name={tab.id}
          isActive={tab.id === activeTab.id}
          on:click={onTabClick}
        >
          {tab.name}
        </Tab>
      {/each}
    </div>
    <div slot="content">
      {#each tabs as tab (tab.id)}
        <TabContent tabData={tab} isActive={tab.id === activeTab.id}>
          {#if fileData[tab.data_key]}
            <ul class="file-list">
              {#each fileData[tab.data_key] as item}
                <li>
                  {#if item.id && item.description}
                    <VideoContent video={item} />
                  {:else}
                    <FileItem file={item} />
                  {/if}
                </li>
              {/each}
            </ul>
          {:else}
            <p>Momentan stehen für diese Sektion keine Daten zur Verfügung.</p>
          {/if}
        </TabContent>
      {/each}
    </div>
  </Tabbed>
{/if}
